import { SiteProvider } from './siteProvider.ts';

export interface BatchJobRecord {
  state: string;
  startAt: string;
  endAt: string;
}

export interface CronSettings {
  minute: string;
  hour: string;
  monthday: string;
  month: string;
  weekday: string;
}

export interface ParkingBillingSettingRule {
  type: string;
  settings: CronSettings;
}

export interface PeriodRelative {
  offsetUnit: string;
  offset: string;
  day: string;
  time: string;
}

export interface ReportPeriod {
  start: PeriodRelative;
  end: PeriodRelative;
}

export interface ParkingBillingSettingArgs {
  partnerId: string;
  storeIds: string[];
  accountantIds: string[];
  billingTags: string[];
  reportPeriod: ReportPeriod;
}

export function convertToReportPeriodType(reportPeriod: ReportPeriod): string {
  let reportPeriodType = '';
  if (reportPeriod.start.offsetUnit === 'week') {
    reportPeriodType = 'week';
  } else {
    const startDay = reportPeriod.start.day;
    const endDay = reportPeriod.end.day;
    if (startDay === '1' && endDay === '31') {
      reportPeriodType = 'month';
    } else {
      reportPeriodType =
        startDay === '1' && endDay === '15'
          ? 'firstHalfOfMonth'
          : 'secondHalfOfMonth';
    }
  }
  return reportPeriodType;
}

export interface ParkingBillingSetting {
  id: string;
  type: string;
  name: string;
  createdAt: string;
  siteProvider: SiteProvider;
  lastBatchJobRecord: BatchJobRecord | null;
  scheduledTaskTriggerRule: ParkingBillingSettingRule;
  args: ParkingBillingSettingArgs;
}
